export default __webpack_public_path__ + "static/media/plus-grey-bold.6f0a8a30.svg";